module.exports = __webpack_public_path__ + "img/13.6a57ded4.jpg";